import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { get } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from '../../../formatted-currency';
import { DiscountPropType } from '../../../../prop-types/discount';

import style from './purchase-details.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const Discounts = ({ discounts = emptyArray }) => {
  if (discounts.length) {
    const description = get(discounts, '0.description', '');
    const currencyCode = get(discounts, '0.amount.code', 'USD');
    const value = discounts.reduce((a, b) => {
      const amount = get(b, 'amount.value', 0);
      return a + amount;
    }, 0);
    return (
      <div className={classnames(style['detail-line'], style.underlined)}>
        <div>
          <FormattedMessage
            defaultMessage='Discount ({desc})'
            description='orderDetails.discountTotal'
            id='AkamWE'
            values={{ desc: description }}
          />
        </div>
        <div>
          <FormattedCurrency currencyCode={currencyCode} value={value} />
        </div>
      </div>
    );
  }
  return null;
};

Discounts.propTypes = {
  discounts: PropTypes.arrayOf(DiscountPropType),
};

export default Discounts;
